import { type ActionItem } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { type ICallingListResponse } from 'entities/AICalling/api/types'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'

export const edit = (item: ICallingListResponse): ActionItem => {
  return {
    text: 'Edit',
    icon: 'edit',
    onAction: () => {
      uiStore.changeRoute({
        path: ChatbotPath.callingEdit(item.id),
      })
    },
  }
}
